import { appConstants } from "../helpers/constants";

const initialState = {
  startDate: null,
  endDate: null,
};

const varsReducer = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.SET_START_DATE:
      return {
        ...state,
        startDate: action.startDate,
      };
    case appConstants.SET_END_DATE:
      return {
        ...state,
        endDate: action.endDate,
      };

    default:
      return state;
  }
};

export default varsReducer;
